import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SOURCE_URL } from "../../../config";
import Swiper from 'swiper';
import 'swiper/css/bundle';
import { swiperConfigs } from './BlogSwiperConfigs';
import language from '../../../utils/LanguageSettings';
import translations from '../../../text/get-started-translations.json';

const BlogHotArticles: React.FC<{ hotArticles: any[] }> = ({ hotArticles }) => {
  const pageTranslations = translations[language];
  const initializeSwiper = () => {
    document.querySelectorAll<HTMLElement>(".swiper-container").forEach((container) => {
      const slideCount = container.querySelectorAll(".swiper-slide").length;

      if (slideCount === 1) {
        container.querySelectorAll<HTMLElement>(".swiper-button-next, .swiper-button-prev").forEach(button => button.style.display = 'none');
      } else if (slideCount === 2) {
        new Swiper(container as HTMLElement, swiperConfigs.config2);
      } else if (slideCount === 3) {
        new Swiper(container as HTMLElement, swiperConfigs.config3);
      } else if (slideCount > 3) {
        new Swiper(container as HTMLElement, swiperConfigs.config4);
      }
    });
  };

  const formatDate = (dateString: string) => {
    if (!dateString) {
      return null;
    }
    const date = new Date(dateString);
    if (language === 'en') {
      const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      const day = date.getDate();
      const monthIndex = date.getMonth();
      const year = date.getFullYear();
      return `${day} ${monthNames[monthIndex]} ${year}`;
    }
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('zh-HK', options);
  };

  useEffect(() => {
    if (hotArticles) {
      initializeSwiper();
    }
  }, [hotArticles]);

  return (
    <div className="hot-articles-wrapper">
      {/* hot articles */}
      {hotArticles && hotArticles.length > 0 &&
        <div className="container">
          <h2>{pageTranslations.HotTopics}</h2>
          <div className="swiper-container">
            <div className="swiper-wrapper">
              {hotArticles.slice(0, 10).map((article) => (
                <div key={article.id} className="swiper-slide">
                  <Link to={`${article.attributes.slug}`} className="item">
                    <div className="card">
                      <img className="card-img-top" src={article?.attributes?.FeaturedImage?.data?.attributes?.formats?.small?.url ? SOURCE_URL + article.attributes.FeaturedImage.data.attributes.formats.small.url : ''} alt="Card image cap" />
                      <div className="card-header">
                        <h3>{article.attributes.Title}</h3>
                      </div>
                      <div className="card-body">
                        <small>{formatDate(article.attributes.updatedAt)}</small>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
            {/* Navigation arrows */}
            <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div>
          </div>
        </div>
      }
    </div>
  );
};

export default BlogHotArticles;